import { Heart, MessageCircle, Share2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PostActions({ post, commentsCount, onToggleComments }) {
  const { user } = useAuth();
  const [liked, setLiked] = useState(post.liked_by_me);
  const [likes, setLikes] = useState(post.likes_count);

  const toggleLike = async () => {
    try {
      const { data } = await api.post(`/posts/${post.id}/like`);
      setLiked(data.liked_by_me);
      setLikes(data.likes_count);
    } catch (err) {
      console.error("Failed to toggle like:", err);
    }
  };

  const sharePost = async () => {
    const url = `${window.location.origin}/p/${post.id}`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — share it with anyone, no account needed");
    } catch (err) {
      console.warn("Clipboard unavailable, falling back to prompt:", err?.message);
      window.prompt("Copy this link:", url);
    }
  };

  return (
    <div className="flex items-center gap-2 px-2 py-2 border-t border-[#262626]">
      <button
        data-testid={`post-like-${post.id}`}
        onClick={toggleLike}
        disabled={!user}
        className={`flex items-center gap-2 px-3 py-2 rounded-sm text-sm transition-colors ${
          liked
            ? "text-red-500 hover:bg-[#1a1a1a]"
            : "text-[#a3a3a3] hover:text-white hover:bg-[#1a1a1a]"
        }`}
      >
        <Heart className={`w-4 h-4 ${liked ? "fill-red-500" : ""}`} />
        <span data-testid={`post-likes-count-${post.id}`}>{likes}</span>
      </button>
      <button
        data-testid={`post-comment-toggle-${post.id}`}
        onClick={onToggleComments}
        className="flex items-center gap-2 px-3 py-2 rounded-sm text-sm text-[#a3a3a3] hover:text-white hover:bg-[#1a1a1a] transition-colors"
      >
        <MessageCircle className="w-4 h-4" />
        <span data-testid={`post-comments-count-${post.id}`}>{commentsCount}</span>
      </button>
      <button
        data-testid={`post-share-${post.id}`}
        onClick={sharePost}
        className="flex items-center gap-2 px-3 py-2 rounded-sm text-sm text-[#a3a3a3] hover:text-white hover:bg-[#1a1a1a] transition-colors ml-auto"
      >
        <Share2 className="w-4 h-4" />
        <span className="hidden sm:inline">Share</span>
      </button>
    </div>
  );
}
